const readJson = async (file: File): Promise<unknown> =>
  new Promise<unknown>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (result === null || result instanceof ArrayBuffer) {
        reject(new Error('Unsupported type'));
      } else {
        resolve(JSON.parse(result));
      }
    };
    reader.onerror = () => reject(new Error('Error reading file'));
    reader.readAsText(file);
  });

export default readJson;
